import Api from 'api/index'

const config = {
  baseURL: '/api/app/v1/payout-profiles',
}

const api = new Api(config)

api.fetchProfiles = ({ ...rest }) => api.get('', { ...rest })

api.create = ({ ...rest }) => api.post('', { ...rest })

api.fetchById = ({ profileId, ...rest }) =>
  api.get(`/${profileId}`, { ...rest })

api.update = ({ profileId, ...rest }) => api.patch(`/${profileId}`, { ...rest })

export default api
